// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2QD5f","title":"AfterFrontImage_title__W_trB"};